import {
  getActivityBridge as getDesktopActivityBridge,
  webBridge,
} from '@daysheetly/desktop-bridge';
import type { ActivityBridge } from './activityAssistant.types';

export function createWebActivityBridge(): ActivityBridge {
  return webBridge;
}

/**
 * Resolve the bridge at call time so Vitest and Playwright can inject a
 * deterministic fake before React mounts. The desktop shell installs the
 * same interface and delegates it to Tauri IPC; regular browsers get a safe
 * unsupported bridge that never attempts native access.
 */
export function getActivityBridge(): ActivityBridge {
  return window.__DAYSHEETLY_ACTIVITY_BRIDGE__ ?? getDesktopActivityBridge();
}
